import { render, staticRenderFns } from "./CoolFrame.vue?vue&type=template&id=eced3556&scoped=true"
import script from "./CoolFrame.vue?vue&type=script&lang=js"
export * from "./CoolFrame.vue?vue&type=script&lang=js"
import style0 from "./CoolFrame.vue?vue&type=style&index=0&id=eced3556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eced3556",
  null
  
)

export default component.exports